<template>
  <div class="hello">
    <header>
      <div class="h_left">
        <transition name="el-zoom-in-center">
          <div v-show="is_show" class="transition-box">
            <div class="h_box">
              <!-- <div class="h_top">
                <p class="red">D</p>
                <p class="red">I</p>
                <p class="red">O</p>
                <p class="red">P</p>
                <p>R</p>
                <p>A</p>
                <p>X</p>
              </div>
              <div class="h_b">
                <p>Digitize</p>
                <i></i>
                <p>Optimize</p>
                <i></i>
                <p>Transform</p>
                <i></i>
                <p>Experience</p>
              </div> -->
              <img src="../assets/images/LOGO.png" alt="" />
            </div>
          </div>
        </transition>
      </div>
      <div class="h_grith">
        <p>首页</p>
        <p @click="scrollToCmtList('box_title1')">即时通讯枢纽</p>
        <p @click="scrollToCmtList('box_title3')">Zendesk介绍</p>
        <p @click="scrollToCmtList('box_title2')">行业案例</p>
        <p @click="scrollToCmtList('box_title4')">关于我们</p>
      </div>
    </header>
    <div class="img_bar">
      <div class="title1">
        携手Zendesk , 助力企业打造
        <p>最佳客户体验</p>
      </div>
      <div class="title2">
        新一代云端智能商业应用 , 整合CRM和ERP , 无缝集成 , 灵活扩展
      </div>
      <div
        class="title3"
        v-on:mouseover="changeActive('is_eym')"
        v-on:mouseout="removeActive('is_eym')"
      >
        联系销售人员
      </div>
      <div class="eym">
        <transition name="el-zoom-in-top">
          <div v-show="is_eym" class="transition-box">
            <img
              src="../assets/images/1 banner 点击 联系销售人员 显示二维码.jpg"
              alt=""
            />
          </div>
        </transition>
      </div>
      <div class="login1">
        <!-- <img src="../assets/images/1 banner 插图.png" alt="" /> -->
      </div>
    </div>
    <div class="box">
      <div class="title_box">
        <div class="bocak">
          <div id="box_title1" class="box_title1">即时通讯枢纽</div>
          <i class="i1"></i>
        </div>
      </div>

      <div class="box_nav1">
        <div class="nav1">
          <img :src="require('../assets/images/A 130x130/1.png')" alt="" />
          <div class="title">微信</div>
        </div>
        <div class="nav1">
          <img :src="require('../assets/images/A 130x130/2.png')" alt="" />
          <div class="title">WhatsApp</div>
        </div>
        <div class="nav1">
          <img :src="require('../assets/images/A 130x130/3.png')" alt="" />
          <div class="title">Line</div>
        </div>
        <div class="nav1">
          <img :src="require('../assets/images/A 130x130/4.png')" alt="" />
          <div class="title">Messenger</div>
        </div>
        <div class="nav1">
          <img :src="require('../assets/images/A 130x130/5.png')" alt="" />
          <div class="title">Instagram</div>
        </div>
      </div>
      <div class="box_title2">
        将多个支持渠道统一接入到一个平台中 , 以获得更快的回复和无缝的交流。
      </div>
      <div class="box_list_msg">
        <img :src="require('../assets/images/B 57x57/2.png')" alt="" />
        <div class="list_msg">
          无缝切换对话渠道，并根据客户系统的渠道进行响应，节省时间、降低成本。
        </div>
      </div>
      <div class="box_list_msg">
        <img :src="require('../assets/images/B 57x57/3.png')" alt="" />
        <div class="list_msg">
          在各个客户旅程触点，随时随地打造轻松的客户体验，提升客户满意度。
        </div>
      </div>
      <div class="box_list_msg">
        <img :src="require('../assets/images/B 57x57/4.png')" alt="" />
        <div class="list_msg c">
          扩展性强且灵活度高的业务平台，可以嵌入到您核心系统的任何地方。以便客户获得丰富的、定制的体验。
          <!-- <p>以便客户获得丰富的、定制的体验</p> -->
        </div>
      </div>
      <div class="box_list_msg">
        <img :src="require('../assets/images/B 57x57/5.png')" alt="" />
        <div class="list_msg">
          开箱即用的更佳实践能够让您更灵活的快速的处理业务。
        </div>
      </div>
      <div class="box_list_msg">
        <img :src="require('../assets/images/B 57x57/6.png')" alt="" />
        <div class="list_msg">
          智能交互的客户环境，为客户量身打造理想的客户之旅，提高您在整个客户生命周期中的参与度。
        </div>
      </div>
    </div>
    <div class="contenr">
      <div class="title_box">
        <div class="bocak">
          <div id="box_title3" class="c_title1">Zendesk助力企业成就业绩增长</div>
          <i class="i1"></i>
        </div>
      </div>

      <div class="c_box">
        <div class="c_lef">
          <video
            ref="video"
            class="play-video"
            controls="controls"
            :src="require('../assets/video/big_buck_bunny.mp4')"
            type="video/mp4"
          ></video>
          <i></i>
        </div>
        <div class="c_right">
          <div class="c_top">
            Zendesk成立于2007年。作为一家服务至上的CRM供应商,Zendesk致力于成为企业提供支持自定义扩展的完整客户服务解决方案，改善客户关系，创造无缝客户体验。
          </div>
          <div class="c_bottom">
            目前Zendesk的客户服务方法已受到全球160多个国家的16万多客户的信任。90%的客户可以在8周或更短的时间内完成Zendesk系统的部署，投资回报期不超过6个月，3年内看到的总投资回报率可达到286%。
          </div>
        </div>
      </div>
      <div class="c_title2">
        通过8个核心产品，您的团队可以实现共享客户数据、客户历史信息和沟通渠道。
      </div>
      <div class="c_list">
        <div class="c_list_box">
          <img :src="require('../assets/images/C 99x99/1.jpg')" alt="" />
          <i>Suite</i>
          <div class="title_c"><div>完整客户服务解决方案套件</div></div>
          <p>用客户喜欢的方式提供支持，以便客户轻松获得所需答案。</p>
        </div>
        <div class="c_list_box">
          <img :src="require('../assets/images/C 99x99/2.jpg')" alt="" />
          <i>Support</i>
          <div class="title_c"><div>工单处理系统</div></div>
          <p>用于追踪、排列优先等级和解决客户支持工地那系统。</p>
        </div>
        <div class="c_list_box">
          <img :src="require('../assets/images/C 99x99/3.jpg')" alt="" />
          <i>Guide、Gather</i>
          <div class="title_c"><div>知识库和智能自助服务</div></div>
          <p class="p1">
            智慧型号知识库、让客户实现自助服务，提高解决问题的效率。
          </p>
        </div>
        <div class="c_list_box">
          <img :src="require('../assets/images/C 99x99/4.jpg')" alt="" />
          <i>Chat</i>
          <div class="title_c"><div>实时聊天和消息传递</div></div>
          <p class="p1">
            提供了一种快速有效的响应方式，为客户提供帮助，而无需中断其体验、与客户实现实时聊天。
          </p>
        </div>
        <div class="c_list_box">
          <img :src="require('../assets/images/C 99x99/5.jpg')" alt="" />
          <i>Explore</i>
          <div class="title_c"><div>报告和分析</div></div>
          <p class="p2">帮助分析、理解和共享业务信息。</p>
        </div>
        <div class="c_list_box">
          <img :src="require('../assets/images/C 99x99/6.jpg')" alt="" />
          <i>Sell</i>
          <div class="title_c">
            <div>销售CRM</div>
          </div>
          <p class="p1">
            利用自动化软件来提高销售人员的工作效率、流程和管道可见度。
          </p>
        </div>
        <div class="c_list_box">
          <img :src="require('../assets/images/C 99x99/7.jpg')" alt="" />
          <i>Sunshine</i>
          <div class="title_c"><div>开放式CRM平台</div></div>
          <p class="p1">
            建立在AWS上，无论您身在何处，都可以无缝访问客户数据，随时创造最佳的客户体验。
          </p>
        </div>
        <div class="c_list_box">
          <img :src="require('../assets/images/C 99x99/8.jpg')" alt="" />
          <i>Talk</i>
          <div class="title_c"><div>呼叫中心</div></div>
          <p class="p1">与客户直接交谈，给复杂的问题提供个性化的解决方案。</p>
        </div>
      </div>
      <div class="c_b">
        <div class="list_msg">
          <div class="msg_num">160<i>+</i></div>
          <p>服务国家</p>
        </div>
        <div class="list_msg">
          <div class="msg_num"><i>&lt;</i> 16000 <i>+</i></div>
          <p>服务客户</p>
        </div>
        <div class="list_msg">
          <div class="msg_num"><i>&lt;</i>8<i>周</i></div>
          <p>完成部署</p>
        </div>
        <div class="list_msg">
          <div class="msg_num"><i>&lt;</i>6<i>月</i></div>
          <p>回报率</p>
        </div>
        <div class="list_msg">
          <div class="msg_num"><i>~</i>286<i>%</i></div>
          <p>3年内总投资回报率</p>
        </div>
      </div>
    </div>

    <div class="bgcf">
      <div class="hyal">
        <div id="box_title2" class="box_title1">行业案例</div>
        <i class="i1"></i>
      </div>
      <div class="img_nav">
        <div
          class="img_nav_box"
          v-for="(item, index) in msglist"
          :key="index"
          @click="indexNum(index)"
        >
          <p :class="index == num ? 'color' : ''">{{ item }}</p>
          <i :class="index == num1 ? 'color1' : ''"></i>
        </div>
      </div>
      <div class="lbt">
        <el-carousel
          :interval="40000"
          type="card"
          height="480px"
          indicator-position="none"
          @change="qh"
          ref="carousel"
        >
          <el-carousel-item v-for="(item, index) in imgList" :key="index">
            <div class="img">
              <img :src="item.img" alt="" />
              <div class="img_text">
                <i :class="index == num ? '' : 'i_p'" :id="'i_p' + index">{{
                  item.name
                }}</i>
                <p :class="index == num ? '' : 'i_p'">
                  {{ item.text }}
                </p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div id="li50" class="hy">
        <div class="div">
          <div id="box_title4" class="box_title1">为什么选择谛胜</div>
          <i class="i1"></i>
        </div>
      </div>
      <div class="p_msg1">
        谛胜云是一家客户体验的咨询公司，涉及的领域包括营销、销售与售后。不论您是B2B或B2C的企业，我们跨亚太的150个专家助您在全球领先的平台上为您搭建量身定做的行业解决方案，通过最佳使用帮您实现卓越的客户及用户体验。
      </div>
      <div class="p_msg2">
        谛胜始终坚持和践行以 "Digital、Optimize、Transform、Experience"
        为核心，致力于通过云计算机、大数据、AI等数字化转型技术，驱动商业智能、优化客户体验，助力企业实现持续获取客户与胜利。
      </div>
      <div class="fwjs">
        <div class="fwjs_box">
          <div class="f_left">
            <img src="../assets/images/E 80/未标题-2_0003_1.jpg" alt="" />
          </div>
          <div class="f_right">
            <div class="f_top">
              <i></i>
              <p>专业咨询实施</p>
            </div>
            <div class="f_bottom">
              长期专注于数字化营销领域。通过丰富的行业知识和优良实践，为您提供专业建议。通过使用专业平台，帮助您实现业务增长和扩展。
            </div>
          </div>
        </div>
        <div class="fwjs_box">
          <div class="f_left">
            <img src="../assets/images/E 80/未标题-2_0002_2.jpg" alt="" />
          </div>
          <div class="f_right">
            <div class="f_top">
              <i></i>
              <p>创新解决方案</p>
            </div>
            <div class="f_bottom">
              充分利用AI和其它新兴技术，给您打造专属的解决方案，找到适合您企业发展的更佳经营之路。
            </div>
          </div>
        </div>
        <div class="fwjs_box">
          <div class="f_left">
            <img src="../assets/images/E 80/未标题-2_0001_3.jpg" alt="" />
          </div>
          <div class="f_right">
            <div class="f_top">
              <i></i>
              <p>一站式业务支持</p>
            </div>
            <div class="f_bottom">
              依靠云服务的便捷性、灵活性和可扩展性、一站式提供售前咨询，售中实施和售后运维的业务支持服务。
            </div>
          </div>
        </div>
        <div class="fwjs_box">
          <div class="f_left">
            <img src="../assets/images/E 80/未标题-2_0000_4.jpg" alt="" />
          </div>
          <div class="f_right">
            <div class="f_top">
              <i></i>
              <p>客户成功服务</p>
            </div>
            <div class="f_bottom">
              丰富的资源、全面的服务渠道。旨在以下客户为中心，为客户创造价值。客户的成功就是我们的成功。
            </div>
          </div>
        </div>
      </div>
      <div class="hzhb">合作伙伴</div>
      <div class="hzhb_list">
        <img :src="require('../assets/images/Z 底部1 LOGO.png')" alt="" />
        <img :src="require('../assets/images/Z 底部2 LOGO.png')" alt="" />
      </div>

      <div class="bottom">
        <div class="b_list">
          <img
            :src="require('../assets/images/Z 最底部图标/电话.png')"
            alt=""
          />
          <div class="msg_b">
            <div class="left">联系电话 :</div>
            <div class="right">
              <p class="p">021-32567992</p>
              <p>17267202860</p>
            </div>
          </div>
        </div>
        <div class="b_list">
          <img
            :src="require('../assets/images/Z 最底部图标/住址.png')"
            alt=""
          />
          <div class="msg_b">
            <div class="left">地址 :</div>
            <div class="right">
              <p>上海市金山区枫泾镇建贡路63号3幢二楼210室</p>
            </div>
          </div>
        </div>
        <div class="b_list">
          <img
            :src="require('../assets/images/Z 最底部图标/邮箱.png')"
            alt=""
          />
          <div class="msg_b">
            <div class="left">Email :</div>
            <div class="right">
              <p>dannapan@dioptrax.com</p>
            </div>
          </div>
        </div>
        <!--
        <div class="b_list">
          <img
            src="../assets/images/备案图标.png"
            alt=""
          />
          <div class="msg_b">
            <div class="left">备案图标 :</div>
            <div class="right">
              <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502006335">
              <p>沪公网安备 31010502006335号</p>
              </a>
            </div>
          </div>
        </div>
        -->

	  <!--
	   <div style="width:300px;margin:0 auto; padding:20px 0;">
      		<a target="_blank"
      		  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502006335"
      		  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
      		  <img src="D" style="float:left;"/>
      		  <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31010502006335号</p>
      		</a>
      	   </div>
      	   -->
  

      </div>
 
	  <div class="bottom" style="justify-content: center;height: 80px;margint-top: -30px;">
		  
          <div class="b_list">
			<span style="color:#d2cfcf;">谛胜云计算(dioptrax.com) &nbsp;&nbsp; 网站备案：</span>
			<a href="https://beian.miit.gov.cn/ " rel="nofollow" target="_blank" style="color:#d2cfcf;">沪ICP备2020028836号-1</a>	 
			<a target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502006335"
              style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <img src="../assets/images/备案图标.png" style="float:left;"/>
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#d2cfcf;">沪公网安备 31010502006335号</p>
            </a>
          </div>
      </div>

<!-- 	  
	 <div class="bottom"  
	      span style="font-size:14px;">谛胜云计算(dioptrax.com) &nbsp;&nbsp; 网站备案：< a href=" " rel="nofollow" target="_blank">沪ICP备2020028836号-1</ a>
	       <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502006335" 
		   style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
		   < img src="../assets/images/备案图标.png" style="float:left;"> 沪公网安备 31010502006335号 </ a>
	     </span>
     </div>
-->	  
      <div class="pof" style="z-index: 999999999999999999999">
        <div class="p_left">
          <transition name="el-fade-in">
            <div v-show="show" class="transition-box">
              <div class="pof_box">
                <div class="p_titile">
                  <p>在线客服</p>
                  <i class="el-icon-close" @click="show = false"></i>
                </div>
                <div class="p_box" id="box">
                  <div class="p_b_left">
                    <div class="p_top">
                      <img
                        :src="require('../assets/images/36x36 客服头像.png')"
                        alt=""
                      />
                      <p>上海谛胜云计算有限公司 <i>10:00:00</i></p>
                    </div>
                    <div class="text">
                      谛胜云是一家客户体验的咨询公司，涉及的领域包括营销、销售与售后。不论您是B2B或B2C的企业，我们跨亚太的150个专家助您在全球领先的平台上为您搭建量身定做的行业解决方案，通过最佳使用帮您实现卓越的客户及用户体验。
                    </div>
                  </div>
                  <div class="p_b_left">
                    <div class="p_top">
                      <img
                        :src="require('../assets/images/36x36 客服头像.png')"
                        alt=""
                      />
                      <p>上海谛胜云计算有限公司 <i>10:00:00</i></p>
                    </div>
                    <div class="text">
                      您好，很高兴为您效劳，请问有什么可以帮助您？
                    </div>
                  </div>
                  <div class="p_b_left">
                    <div class="p_top">
                      <img
                        :src="require('../assets/images/36x36 客服头像.png')"
                        alt=""
                      />
                      <p>上海谛胜云计算有限公司 <i>10:00:00</i></p>
                    </div>
                    <div class="text">
                      如果没有及时回复您，可以拨打电话号码021-32567992或17267202860，谢谢。
                    </div>
                  </div>
                  <div
                    class="P_b_right"
                    v-for="(item, index) in listMsg"
                    :key="index"
                  >
                    <div class="p_top">
                      <p>
                        <i>{{ item.date }}</i> 勿忘心安丶
                      </p>
                      <img
                        :src="require('../assets/images/36x36 客户头像.png')"
                        alt=""
                      />
                    </div>
                    <div class="text">
                      <p>{{ item.text }}</p>
                    </div>
                  </div>
                </div>
                <div class="input_">
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                    placeholder="请输入内容"
                    v-model="textarea"
                  ></textarea>
                  <div class="btn">
                    <button @click="tbn_msg">发送</button>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="p_right">
          <div class="right_box_l">
            <transition name="el-fade-in-linear">
              <div v-show="show2" class="transition-box">
                <div
                  class="img_box"
                  v-for="(item, index) in img_list1"
                  :key="index"
                >
                  <img
                    :src="item.img"
                    alt=""
                    v-on:mouseover="changeActive(item.name)"
                    v-on:mouseout="removeActive(item.name)"
                  />
                </div>
              </div>
            </transition>
          </div>
          <div class="img_box">
            <img
              :src="
                show2
                  ? require('../assets/images/0 展开后及缩小悬浮按钮/7 缩小SNS悬浮按钮.png')
                  : require('../assets/images/0 未展开悬浮按钮/1 SNS图标展开按钮.png')
              "
              alt=""
              @click="F_show2"
            />
          </div>
          <div class="img_box">
            <img
              :src="
                show
                  ? require('../assets/images/0 展开后及缩小悬浮按钮/8 关闭在线聊天.png')
                  : require('../assets/images/0 未展开悬浮按钮/2 在线聊天展开按钮.png')
              "
              @click="show = !show"
              alt=""
            />
          </div>
          <div class="erweima1">
            <transition name="el-zoom-in-center">
              <div v-show="is_ewm0" class="transition-box">
                <div class="ewm_box">
                  <div>
                    <p>【电话】</p>
                    <p class="p">021-32567992</p>
                    <p class="p">17267202860</p>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="erweima2">
            <transition name="el-zoom-in-center">
              <div v-show="is_ewm1" class="transition-box">
                <div class="ewm_box">
                  <img src="../assets/images/2 企业微信.png" alt="" />
                  <p>【企业微信】</p>
                </div>
              </div>
            </transition>
          </div>
          <div class="erweima2 erweima3">
            <transition name="el-zoom-in-center">
              <div v-show="is_ewm2" class="transition-box">
                <div class="ewm_box">
                  <img src="../assets/images/3 微信公众号.png" alt="" />
                  <p>【公众号】</p>
                  <p>谛胜云计算</p>
                </div>
              </div>
            </transition>
          </div>
          <div class="erweima2 erweima4">
            <transition name="el-zoom-in-center">
              <div v-show="is_ewm3" class="transition-box">
                <div class="ewm_box">
                  <img src="../assets/images/4 WhatsApp.png" alt="" />
                  <p>【WhatsApp】</p>
                  <p>ID：+86 17267202860</p>
                </div>
              </div>
            </transition>
          </div>
          <div class="erweima2 erweima5">
            <transition name="el-zoom-in-center">
              <div v-show="is_ewm4" class="transition-box">
                <div class="ewm_box">
                  <p>【Messenger】</p>
                  <p>ID：Dioptrax</p>
                </div>
              </div>
            </transition>
          </div>
          <div class="erweima2 erweima6">
            <transition name="el-zoom-in-center">
              <div v-show="is_ewm5" class="transition-box">
                <div class="ewm_box">
                  <img id="img" src="../assets/images/6 line.png" alt="" />
                  <p>【line】</p>
                  <p>ID：@911qlrtu</p>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="bj" id="bj">
      <img src="../assets/images/0 顶左上角一直背景悬浮图.jpg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  props: {
    msg: String,
  },
  data() {
    return {
      is_ewm0: false,
      is_ewm1: false,
      is_ewm2: false,
      is_ewm3: false,
      is_ewm4: false,
      is_ewm5: false,
      target: "",
      is_eym: false,
      is_show: false,
      num: 0,
      num1: 0,
      num2: 0,
      textarea: "",
      show2: true,

      show: false,
      img_list1: [
        {
          img: require("../assets/images/0 展开后及缩小悬浮按钮/1 电话.png"),
          name: "is_ewm0",
          is_ewm: false,
        },
        {
          img: require("../assets/images/0 展开后及缩小悬浮按钮/2 企业微信.png"),
          name: "is_ewm1",
          is_ewm: false,
        },
        {
          img: require("../assets/images/0 展开后及缩小悬浮按钮/3 微信服务号.png"),
          name: "is_ewm2",
          is_ewm: false,
        },
        {
          img: require("../assets/images/0 展开后及缩小悬浮按钮/4 WhatsApp.png"),
          name: "is_ewm3",
        },
        {
          img: require("../assets/images/0 展开后及缩小悬浮按钮/5 messenger.png"),
          name: "is_ewm4",
          is_ewm: false,
        },
        {
          img: require("../assets/images/0 展开后及缩小悬浮按钮/6 line.png"),
          name: "is_ewm5",
          is_ewm: false,
        },
        // {
        //   img: require("../assets/images/0 展开后及缩小悬浮按钮/7 缩小SNS悬浮按钮.png"),
        //   name: "iphoem",
        // },
        // {
        //   img: require("../assets/images/0 展开后及缩小悬浮按钮/8 关闭在线聊天.png"),
        //   name: "off",
        // },
      ],
      img_list2: [
        {
          img: require("../assets/images/0 未展开悬浮按钮/1 SNS图标展开按钮.png"),
          name: "iphoem",
        },
        {
          img: require("../assets/images/0 未展开悬浮按钮/2 在线聊天展开按钮.png"),
          name: "iphoem",
        },
      ],
      listMsg: [
        {
          text: "测试数据",
          date: "10:00:20",
        },
      ],
      imgList: [
        {
          img: require("../assets/images/D 左右滑动/1.jpg"),
          name: "零售行业",
          text: "基于丰富的案例实践和经验积累，为消费品/零售行业/奢侈行业等量身定制专业的解决方案，帮助企业实现全渠道的客户交互和体验。",
        },
        {
          img: require("../assets/images/D 左右滑动/2.jpg"),
          name: "汽车行业",
          text: "众多行业龙头转型成功案例，为汽车行业实现智能化服务营销管理平台，从洞察分析、智能营销到优化服务的闭环管理。",
        },
        {
          img: require("../assets/images/D 左右滑动/3.jpg"),
          name: "游戏行业",
          text: "建立以玩家为中心的敏捷服务体系，加速接收，注册、服务和支持。提供安全、灵活和易于使用的解决方案，实现个性化娱乐之旅。",
        },
        {
          img: require("../assets/images/D 左右滑动/4.jpg"),
          name: "其它行业",
          text: "无论您的发展速度如何，谛胜和Zendesk搭建一体化的信息管控营销和服务平台的解决方案能帮助您快速跟上客户步伐，在全数字化环境中蓬勃发展。实现业务流程管控，优化企业运作方式，打造高效办公、销售和移动服务。为团队的成功做好准备。",
        },
      ],
      msglist: ["零售行业", "汽车行业", "游戏行业", "其它行业"],
    };
  },
  created() {
    this.set1();
    // this.set2();
  },

  //先获取目标位置距离
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        let targetbox = document.getElementById("li50");
        this.target = targetbox.offsetTop;
      });
    });
  },
  methods: {
    // 回到指定位置
    scrollToCmtList(id) {
      // document.documentElement.scrollTop = this.target;
      document.getElementById(id).scrollIntoView();
      // console.log(id);
    },
    // 鼠标移入加入class
    changeActive(item) {
      this[item] = true;
    },
    removeActive(item) {
      this[item] = false;
    },
    F_show2() {
      this.show2 = !this.show2;
    },
    indexNum(index) {
      this.$refs.carousel.setActiveItem(index);
    },
    qh(e) {
      console.log(e);
      this.num = e;
      this.num1 = e;
    },
    getCurrentTime() {
      var date = new Date(); //当前时间
      var year = date.getFullYear(); //返回指定日期的年份
      var month = this.repair(date.getMonth() + 1); //月
      var day = this.repair(date.getDate()); //日
      var hour = this.repair(date.getHours()); //时
      var minute = this.repair(date.getMinutes()); //分
      var second = this.repair(date.getSeconds()); //秒

      //当前时间
      var curTime =
        // year +
        // "-" +
        // month +
        // "-" +
        // day +
        // " " +
        hour + ":" + minute + ":" + second;
      return curTime;
    },

    //补0

    repair(i) {
      if (i >= 0 && i <= 9) {
        return "0" + i;
      } else {
        return i;
      }
    },
    tbn_msg() {
      if (this.textarea != "") {
        this.listMsg.push({
          text: this.textarea,
          date: this.getCurrentTime(),
        });
        var div = document.getElementById("box");
        div.scrollTop = div.scrollHeight;
        console.log(div);
      }
      this.textarea = "";
    },
    set1() {
      setTimeout(() => {
        this.is_show = true;
      }, 200);
    },
    set2() {
      setTimeout(() => {
        this.show = true;
      }, 1000);
    },
  },
};
</script>


<style scoped lang='less'>
.hello {
  width: 1900px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  header {
    height: 102px;
    padding: 0 300px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .h_left {
      height: 100%;
      display: flex;
      align-items: center;
      .h_box {
        img {
          width: 207px;
          height: 42px;
        }
        .h_top {
          display: flex;
          justify-content: space-between;
          font-size: 22px;
          margin-bottom: 16px;
          .red {
            color: red;
          }
        }
        .h_b {
          display: flex;
          align-items: center;
          font-size: 8px;
          i {
            width: 2px;
            height: 2px;
            background-color: #000;
            border-radius: 50%;
            margin: 0 10px;
          }
        }
      }
    }
    .h_grith {
      height: 100%;
      display: flex;
      p {
        height: 100%;
        padding: 0 34px;
        line-height: 102px;
        cursor: pointer;
      }
      p:hover {
        background-color: #ffd300;
        color: #7e764b;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .img_bar {
    height: 614px;
    // background-color: #606060;
    background-image: url("../assets/images/1\ banner\ 背景.png.jpg");
    background-size: 100% 100%;
    padding: 188px 0 0 314px;
    box-sizing: border-box;
    position: relative;
    .title1 {
      font-size: 46px;
      font-weight: 700;
      display: flex;
      color: #fff;
      margin-bottom: 44px;
      p {
        color: #ff0000;
      }
    }
    .title2 {
      font-size: 18px;
      color: #fff;
      margin-bottom: 58px;
    }
    .title3 {
      width: 154px;
      height: 44px;
      background-color: #ffd300;
      border-radius: 6px;
      font-size: 18px;
      color: #756f53;
      text-align: center;
      line-height: 44px;
      margin-bottom: 6px;
      cursor: pointer;
    }
    .eym {
      width: 154px;
      height: 154px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .login1 {
      width: 520px;
      height: 360px;
      position: absolute;
      top: 84px;
      right: 88px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .box {
    height: 1000px;
    // background-image: url("../assets/images/0 顶左上角一直背景悬浮图（备用）.png");
    // opacity: .5;
    padding: 66px 0;
    box-sizing: border-box;
    margin-bottom: 74px;
    .title_box {
      width: 700px;
      height: 88px;
      margin: 0 auto;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 40px;
      .box_title1 {
        text-align: center;
        font-size: 40px;
        color: #54595f;
        margin-bottom: 16px;
      }
      .i1 {
        width: 296px;
        height: 10px;
        background-image: url("../assets/images/黄线/即时通讯枢纽黄线.png");
        display: block;
        margin: 0 auto;
      }
    }

    .box_nav1 {
      padding: 0 452px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 36px;
      .nav1 {
        width: 140px;
        padding: 6px 0;
        background-color: #fff;
        img {
          width: 130px;
          height: 130px;
          // border-radius: 50%;
          display: block;
          margin: 0 auto;
          margin-bottom: 40px;
        }
        .title {
          text-align: center;
          font-size: 26px;
          color: #606060;
        }
      }
    }
    .box_title2 {
      width: 1186px;
      height: 56px;
      line-height: 56px;
      margin: 0 auto;
      background-color: #fff;
      text-align: center;
      font-size: 34px;
      color: #606060;
      margin-bottom: 62px;
      position: relative;
    }
    .box_title2::after {
      content: "";
      background-image: url("../assets/images/红左括号.png");
      background-size: 100% 100%;
      width: 22px;
      height: 22px;
      position: absolute;
      top: 0;
      left: 10px;
    }
    .box_title2::before {
      content: "";
      background-image: url("../assets/images/红右括号.png");
      background-size: 100% 100%;
      width: 22px;
      height: 22px;
      position: absolute;
      bottom: 0;
      right: 36px;
    }
    .box_list_msg {
      display: flex;
      margin-left: 540px;
      margin-bottom: 26px;
      img {
        width: 56px;
        height: 56pcx;
        margin-right: 30px;
      }
      .list_msg {
        // width: 640px;
        width: 858px;
        height: 56px;
        font-size: 18px;
        color: #6b6b6b;
        background-color: #fff;
        display: flex;
        align-items: center;
        padding-left: 12px;
        box-sizing: border-box;
      }
      .c {
        flex-wrap: wrap;
      }
    }
  }
  .contenr {
    overflow: hidden;
    .title_box {
      width: 700px;
      height: 88px;
      margin: 0 auto;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 32px;
      .c_title1 {
        text-align: center;
        font-size: 40px;
        color: #54595f;
        margin-bottom: 16px;
      }
      .i1 {
        width: 678px;
        height: 10px;
        display: block;
        margin: 0 auto;
        // margin-bottom: 44px;
        background-image: url("../assets/images/黄线/Zendesk助力企业成就业绩增长\ 黄线.png");
      }
    }

    .c_box {
      display: flex;
      justify-content: center;
      margin-bottom: 68px;
      .c_lef {
        width: 850px;
        height: 480px;
        background-color: pink;
        position: relative;
        margin-right: 16px;
        video {
          width: 100%;
          height: 100%;
        }
      }
      .c_right {
        width: 416px;
        height: 480px;
        display: flex;
        flex-wrap: wrap;
        // align-content:space-between;
        align-content: center;
        font-size: 20px;
        color: #606060;
        padding: 10px 0 10px 0;
        box-sizing: border-box;
        .c_top {
          width: 100%;
          background-color: #fff;
          margin-bottom: 30px;
          line-height: 36px;
          padding: 0 20px;
          box-sizing: border-box;
          letter-spacing: 2px;
          text-align: justify; // 所有行两端对齐
          text-justify: inter-ideograph; // 最后一行居左对齐
        }
        .c_bottom {
          width: 100%;
          background-color: #fff;
          line-height: 36px;
          padding: 0 20px;
          box-sizing: border-box;
          letter-spacing: 2px;
          text-align: justify; // 所有行两端对齐
          text-justify: inter-ideograph; // 最后一行居左对齐
        }
      }
    }
    .c_title2 {
      width: 1180px;
      height: 50px;
      line-height: 50px;
      margin: 0 auto;
      background-color: #fff;
      text-align: center;
      font-size: 28px;
      font-weight: 700;
      color: #606060;
      margin-bottom: 62px;
      letter-spacing: 4px;
      position: relative;
    }
    .c_title2::after {
      content: "";
      background-image: url("../assets/images/红左括号.png");
      background-size: 100% 100%;
      width: 22px;
      height: 22px;
      position: absolute;
      top: 0;
      left: 0;
    }
    .c_title2::before {
      content: "";
      background-image: url("../assets/images/红右括号.png");
      background-size: 100% 100%;
      width: 22px;
      height: 22px;
      position: absolute;
      bottom: 0;
      right:28px;
    }
    .c_list {
      margin: 0 auto;
      width: 1140px;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 36px;
      .c_list_box {
        width: 264px;
        height: 250px;
        border: 1px solid #969696;
        margin: 0 28px 28px 0;
        box-sizing: border-box;
        background-color: #fff;
        img {
          display: block;
          margin: 10px auto 10px auto;
        }
        i {
          display: block;
          text-align: center;
          font-size: 12px;
          margin-bottom: 6px;
        }
        .title_c {
          display: flex;
          justify-content: center;
          margin-bottom: 10px;
          div {
            height: 30px;
            line-height: 30px;
            font-size: 18px;
            color: #606060;
            // background-color: orange;
            text-align: center;
            padding: 0 10px;
            position: relative;
            font-weight: 700;
          }
          div::after {
            content: "";
            background-image: url("../assets/images/灰左括号.png");
            background-size: 100% 100%;
            width: 16px;
            height: 16px;
            position: absolute;
            top: 0;
            left: 0;
          }
          div::before {
            content: "";
            background-image: url("../assets/images/灰右括号.png");
            background-size: 100% 100%;
            width: 16px;
            height: 16px;
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }

        p {
          font-size: 16px;
          text-align: center;
          line-height: 18px;
          padding: 0 26px;
        }
        .p1 {
          padding: 0 4px;
        }
        .p2 {
          padding: 0 44px;
        }
      }
      .c_list_box:nth-child(4n) {
        margin-right: 0;
      }
      .c_list_box:nth-child(4) ~ div {
        margin-bottom: 0;
      }
    }
    .c_b {
      width: 1298px;
      height: 108px;
      background-color: #fff;
      margin: 0 auto 60px auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .list_msg {
        .msg_num {
          font-size: 40px;
          color: #606060;
          margin-bottom: 14px;
          i {
            font-size: 26px;
          }
        }
        p {
          color: #6b6b6b;
          text-align: center;
        }
      }
    }
  }
  .hyal {
    padding: 80px 0 0 0;
    // background-color: pink;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    .box_title1 {
      text-align: center;
      font-size: 40px;
      color: #54595f;
      margin-bottom: 16px;
    }
    .i1 {
      width: 296px;
      height: 10px;
      background-image: url("../assets/images/黄线/行业案例\ 黄线.png");
      display: block;
      margin: 0 auto;
      margin-bottom: 40px;
    }
  }
  .img_nav {
    display: flex;
    justify-content: center;
    font-size: 20px;
    color: #bdbdbd;
    margin-bottom: 40px;
    .img_nav_box {
      margin-right: 30px;
      cursor: pointer;
      p {
        text-align: center;
        line-height: 40px;
      }
      i {
        display: block;
        width: 106px;
        height: 1px;
        background-color: #afafaf;
      }
      .color {
        color: #000;
      }
      .color1 {
        height: 2px;
        background-color: #000;
      }
    }
    .img_nav_box:last-child {
      margin-right: 0;
    }
  }
  .lbt {
    width: 1500px;
    margin: 0 auto;
    .img {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .img_text {
        position: absolute;
        height: 146px;
        width: 100%;
        left: 0;
        top: 50%;
        margin-top: -73px;
        color: #fff;
        font-size: 18px;
        background-color: rgba(0, 0, 0, 0.3);
        i {
          display: block;
          text-align: center;
          margin: 12px 0 30px 0;
        }
        p {
          // text-align: center;
          padding: 0 90px;
          font-size: 18px;
          line-height: 24px;
          letter-spacing: 2px;
          text-align: justify; // 所有行两端对齐
          text-justify: inter-ideograph; // 最后一行居左对齐
        }
        .i_p {
          color: #fff;
          opacity: 0.5;
        }
        #i_p3 {
          margin: 12px 0 10px 0;
        }
      }
    }
  }

  .hy {
    display: flex;
    padding: 140px 0 40px 0;
    justify-content: center;
    .box_title1 {
      text-align: center;
      font-size: 40px;
      color: #54595f;
      margin-bottom: 16px;
    }
    .i1 {
      width: 296px;
      height: 10px;
      background-image: url("../assets/images/黄线/为什么选择谛胜\ 黄线.png");
      background-size: 100% 100%;
      display: block;
      margin: 0 auto;
    }
  }

  .fwjs {
    width: 1290px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    justify-content: space-between;
    .fwjs_box {
      width: 630px;
      height: 130px;
      display: flex;
      align-items: center;
      border: 1px solid #94969a;
      box-sizing: border-box;
      margin-bottom: 60px;
      .f_left {
        margin: 0 28px;
      }
      .f_right {
        height: 100%;
        font-size: 20px;
        .f_top {
          display: flex;
          margin-bottom: 14px;
          margin: 14px 0;
          color: #6b6b6b;
          p {
            font-weight: 700;
          }
          i {
            width: 4px;
            height: 20px;
            background-color: #ff0000;
            border-radius: 4px;
            margin-right: 10px;
          }
        }
        .f_bottom {
          font-size: 18px;
          line-height: 22px;
          color: #6b6b6b;
          text-align: justify; // 所有行两端对齐
          text-justify: inter-ideograph; // 最后一行居左对齐
          padding-right: 20px;
        }
      }
    }
  }

  .hzhb {
    text-align: center;
    font-weight: 700;
    font-size: 24px;
    padding-bottom: 28px;
    color: #6b6b6b;
  }
  .hzhb_list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 68px;
    img {
      margin-right: 214px;
    }
    img:last-child {
      margin-right: 0;
    }
  }
  .bottom {
    height: 138px;
    background-color: #606060;
    padding: 0 308px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .b_list {
      display: flex;
      align-items: center;
      color: #fff;
      img {
        width: 30px;
        height: 30px;
        margin-right: 8px;
      }
      .msg_b {
        display: flex;
        align-items: center;
        .left {
          font-size: 18px;
          margin-right: 16px;
        }
        .right {
          font-size: 18px;
          .p {
            margin-bottom: 6px;
          }
        }
      }
    }
  }
  .pof {
    position: fixed;
    bottom: 30px;
    right: 48px;
    display: flex;
    z-index: 999999999999999999999;
    .p_left {
      margin-right: 28px;
      .pof_box {
        width: 406px;
        height: 518px;
        border-radius: 8px;
        box-shadow: 0 0 10px #000;
        overflow: hidden;
        background-color: #fff;
        .p_titile {
          height: 46px;
          padding: 0 18px;
          box-sizing: border-box;
          background-color: #ffd300;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #fff;
          i {
            font-size: 24px;
            cursor: pointer;
          }
        }
        .p_box {
          height: 364px;
          box-sizing: border-box;
          background-color: #f9f8f8;
          padding: 28px 22px 0 22px;
          overflow: auto;
          .p_b_left {
            margin-bottom: 20px;

            .p_top {
              display: flex;
              align-items: center;
              color: #b3b3b3;
              img {
                width: 34px;
                height: 34px;
                border-radius: 50%;
                margin-right: 10px;
              }
              i {
                margin-left: 20px;
              }
            }
            .text {
              background-color: #fff;
              padding: 14px;
              width: 280px;
              margin-left: 34px;
              line-height: 20px;
            }
          }
          .P_b_right {
            width: 100%;
            overflow: hidden;
            margin-bottom: 20px;
            .p_top {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              color: #b3b3b3;
              img {
                width: 34px;
                height: 34px;
                border-radius: 50%;
                margin-left: 10px;
              }
              i {
                margin-right: 20px;
              }
            }
            .text {
              text-align: right;
              p {
                padding: 14px;
                line-height: 20px;
                margin-right: 34px;
                background-color: #fff;
                display: inline-block;
              }
            }
          }
        }
        .p_box::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        .input_ {
          height: 108px;
          // background-color: pink;
          textarea {
            width: 100%;
            height: 56px;
            padding: 20px 10px 10px 20px;
            border: none;
            outline: none;
            resize: none;
            box-sizing: border-box;
          }
          textarea::-webkit-scrollbar {
            display: none; /* Chrome Safari */
          }
          button {
            width: 66px;
            height: 30px;
            background-color: #ffd300;
            color: #fff;
            text-align: center;
            line-height: 30px;
            border: none;
            border-radius: 6px;
            float: right;
            margin-right: 30px;
            cursor: pointer;
          }
        }
      }
    }
    .p_right {
      width: 56px;
      position: relative;
      .right_box_l {
        height: 394px;
      }
      .img_box {
        display: flex;
        flex-wrap: wrap;
      }
      img {
        display: block;
        cursor: pointer;
        width: 56px;
        height: 56px;
        // border-radius: 50%;
        margin-bottom: 10px;
      }
      .erweima1 {
        position: absolute;
        top: -50px;
        right: 60px;
        width: 130px;
        height: 130px;
        .transition-box {
          width: 100%;
          height: 100%;
        }
        .ewm_box {
          width: 100%;
          height: 100%;
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        p {
          color: #6b6b6b;
          font-size: 10px;
          text-align: center;
          line-height: 14px;
        }
        .p {
          text-align: right;
        }
      }
      .erweima2 {
        position: absolute;
        top: 22px;
        right: 60px;
        width: 130px;
        // height: 200px;
        .transition-box {
          width: 100%;
          height: 100%;
        }
        .ewm_box {
          width: 100%;
          height: 100%;
          background-color: #fff;
          img {
            width: 130px;
            height: 130px;
            margin: 0;
          }
          p {
            font-size: 10px;
            color: #6b6b6b;
            text-align: center;
            line-height: 14px;
          }
        }
      }
      .erweima3 {
        top: 82px;
      }
      .erweima4 {
        top: 142px;
      }
      .erweima5 {
        top: 280px;
      }
      .erweima6 {
        // width: 140px;
        top: 300px;
        #img {
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
  .bj {
    width: 1900px;
    position: fixed;
    top: 100px;
    left: 50%;
    z-index: -1;
    margin-left: -950px;
  }
  // 轮播图
  .p_msg1,
  .p_msg2 {
    font-size: 21px;
    line-height: 24px;
    width: 1290px;
    margin: 0 auto;
    margin-bottom: 24px;
    color: #6b6b6b;
  }
  .p_msg2 {
    margin-bottom: 86px;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }
  .bgcf {
    background-color: #fff;
  }
}
</style>
